<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false" label="sourcesId" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'sourcesId', validatorRules.sourcesId]" placeholder="sourcesId"  :disabled="true"  ></a-input>
        </a-form-item>
        <a-form-item label="账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'apiAccount', validatorRules.apiAccount]" placeholder="请输入账号"></a-input>
        </a-form-item>
        <a-form-item label="类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['apiType', validatorRules.apiType]" :trigger-change="true" dictCode="sy_api_type" placeholder="请选择类型"/>
        </a-form-item>
        <a-form-item label="秘钥" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'secretKey', validatorRules.secretKey]" placeholder="请输入秘钥"></a-input>
        </a-form-item>
        
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'
  import JSelectDepart from '@/components/jeecgbiz/JSelectDepart'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'

  export default {
    name: "BusGisWechatAccountsManagementModal",
    components: {
      JDate,
      JSelectDepart,
      JDictSelectTag,
      JFormContainer,
      JSelectUserByDep,
    },
    data () {
      return {
        managerName:"",
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          apiAccount: {rules: [
            {required: true, message: '请输入账号!'},
          ]},
          apiType: {rules: [
            {required: true, message: '请选择类型!'},
          ]},
          secretKey: {rules: [
            {required: true, message: '请输入秘钥!'},
          ]},
          sourcesId: {rules: [
            {required: true, message: 'sourcesId有误，请重新进入本页面!'},
          ]},
        },
        url: {
          add: "/goldenHomeMsgMange/addApiAccountData",
          edit: "/goldenHomeMsgMange/updateApiAccountData",
        }
      }
    },
    created () {
    },
    methods: {
      realnamefun(val){
        this.managerName=val
      },
      add (record) {
        this.edit(record);
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'apiAccount','apiType','secretKey','sourcesId'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            formData.managerName=this.managerName;
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'name','type','status','sourceType','certificationBody','departmentId','operator','managerPhone','managerId','managerName','annualReviewTime','fanLevel'))
      },
    }
  }
</script>